import type {User} from "../api/accessControl/User.ts";

export const ENTREPRENEUR_CAN_SEE_REPORTS_SETTING = 'ENTREPRENEUR_CAN_SEE_REPORTS';

export function canSeeReports(user: User): boolean {
    return user.businessSettings.getSetting(ENTREPRENEUR_CAN_SEE_REPORTS_SETTING) === true
}
